<script setup>
import {computed, onMounted} from "vue";
import store from "@/store";
import {siteConfig} from "@/utils/config";

const type = computed(() => store.state.coupon)
const banner = computed(() => {
  if(type.value && siteConfig[type.value]) return siteConfig[type.value].banner
});
onMounted(() => {
  store.commit("getCoupon")
})
</script>

<template>
  <div class="banner">
    <!--    {{ `@/assets/images/${type}/banner.png` }}-->
    <el-image :src="banner"/>
  </div>
</template>
<style lang="less" scoped>
.banner {
  box-sizing: border-box;
  padding: 15px;
}
</style>

